@if (check != null && !hasImportResult) {
	<section class="rea-section rea-section--check">
		<div class="rea-section__header">
			<h4>{{ viewState.title }}</h4>
			<p-tag [value]="viewState.countLabel" severity="info" [rounded]="true"></p-tag>
		</div>

		@if (viewState.notice) {
			<p-message severity="warn" [text]="viewState.notice"></p-message>
		}

		@if (check.requiresSelection) {
			<label class="rea-label" for="rea-selector">Selecciona el registro REA que corresponde a esta explotación</label>
			<select
				id="rea-selector"
				class="rea-select"
				[value]="selectedRea"
				(change)="onSelectedReaChange($event)"
			>
				<option value="">Selecciona una explotación</option>
				@for (explotacion of availableExplotaciones; track explotacion.codigoRea) {
					<option [value]="explotacion.codigoRea">
						{{ exploitationOptionLabel(explotacion) }}
					</option>
				}
			</select>

			<p class="rea-check-note">
				Elige el registro que corresponde a esta explotación. Si no estás seguro, comprueba el titular, la comunidad y las parcelas.
			</p>

			@if (invalidSelectedReaMessage) {
				<p-message severity="warn" [text]="invalidSelectedReaMessage"></p-message>
			}
		} @else {
			<p class="rea-check-note">
				@if (viewState.confirmedReaLabel) {
					<b>{{ viewState.confirmedReaLabel }}</b>
				} @else if (viewState.canContinueWithProvidedRea) {
					{{ viewState.providedReaLabel }}
				} @else {
					{{ viewState.emptyLabel }}
				}
			</p>
		}
	</section>
}
